import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAsset6 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.75 0.75H4.75M14.75 0.75H9.03271V6.44768H14.75M14.75 0.75H0.75M14.75 0.75V14.75H0.75M0.75 0.75H4.75M0.75 0.75V14.75M4.75 0.75V5.75V10.75M0.75 14.75L4.75 10.75M14.75 10.75H4.75",
		stroke: "#212121",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgAsset6;
